import {
  FETCH_CHALLANS_REQUEST,
  FETCH_CHALLANS_SUCCESS,
  FETCH_CHALLANS_FAILURE,
} from "../../actions/survey-management/challanActions";

const initialState = {
  loading: false,
  challans: [],
  pagination: {
    page: 1,
    limit: 10,
    totalRecords: 0,
    totalPages: 0,
  },
  error: null,
};

const challanReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CHALLANS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_CHALLANS_SUCCESS:
      return {
        ...state,
        loading: false,
        challans: action.payload.data || [],
        pagination: action.payload.pagination || state.pagination,
        error: null,
      };

    case FETCH_CHALLANS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default challanReducer;
